import { ForemanEmployeeDispatch } from './foreman-employee-dispatch.model';

export interface ForemanJobListItem {
  foremanJobID: string;
  jobID: string;
  vpJobID: string;
  name: string;
  displayName: string;
  workStatus: string;
  employeeCount: number;
  equipmentCount: number;
  employees: ForemanEmployeeDispatch[];
  laborCount: number;
  eqUsageCount: number;
}
